$(window).load(function() {
    var windowHeight = $(window).outerHeight();
    var headerHeight = $('.header').outerHeight();
    var headerAddonTopHeight = $('.header-addon-top').outerHeight();
    var headerAddonBottomHeight = $('.header-addon-bottom').outerHeight();
    var sliderOffsetTop = headerHeight + headerAddonTopHeight + headerAddonBottomHeight;

    $('.slider_big, .slider_big .header-img').css('min-height', windowHeight - sliderOffsetTop);

    mouseIcon('.slider_big,.slider_small', $(window).scrollTop() + 50);
}); 